import { css } from '@emotion/react';
import { Icon, IconName } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { NakedButton, Text } from '@frontend/design-system';

type Props = {
  iconOnly?: boolean;
  iconName: IconName;
  label: string;
  isSelected?: boolean;
  onClick: () => void;
};

export const ContentSwitcherButton = ({ iconOnly, iconName, label, isSelected, onClick }: Props) => {
  return (
    <NakedButton css={containerStyle(isSelected)} onClick={onClick}>
      <Icon name={iconName} size={16} css={{ flexShrink: 0 }} />
      {!iconOnly && (
        <Text size='medium' weight='bold'>
          {label}
        </Text>
      )}
    </NakedButton>
  );
};

const containerStyle = (isSelected?: boolean) =>
  css({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    padding: theme.spacing(0.5, 1),
    borderRadius: theme.borderRadius.small,
    backgroundColor: isSelected ? theme.colors.white : 'transparent',
    ':hover': { backgroundColor: isSelected ? theme.colors.white : theme.colors.neutral20 },
    ...(isSelected && { boxShadow: theme.shadows.light }),
  });
